var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "draft/24/action/list"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3333 4.08325C18.3333 4.49747 17.9975 4.83325 17.5833 4.83325L5.75 4.83325C5.33579 4.83325 5 4.49747 5 4.08325C5 3.66904 5.33579 3.33325 5.75 3.33325H17.5833C17.9975 3.33325 18.3333 3.66904 18.3333 4.08325ZM18.3333 9.91659C18.3333 10.3308 17.9975 10.6666 17.5833 10.6666L5.75 10.6666C5.33579 10.6666 5 10.3308 5 9.91658C5 9.50237 5.33579 9.16658 5.75 9.16659L17.5833 9.16659C17.9975 9.16659 18.3333 9.50237 18.3333 9.91659ZM17.5833 16.4999C17.9975 16.4999 18.3333 16.1641 18.3333 15.7499C18.3333 15.3357 17.9975 14.9999 17.5833 14.9999L5.75 14.9999C5.33579 14.9999 5 15.3357 5 15.7499C5 16.1641 5.33579 16.4999 5.75 16.4999L17.5833 16.4999Z",
    fill: "#008ECC"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 14",
    cx: 3,
    cy: 4,
    r: 1,
    fill: "#008ECC"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 15",
    cx: 3,
    cy: 10,
    r: 1,
    fill: "#008ECC"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 16",
    cx: 3,
    cy: 16,
    r: 1,
    fill: "#008ECC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.8911162affc5d69d8c2ead8126b56ef1.svg";
export { ForwardRef as ReactComponent };